<template>
  <v-snackbar
    v-model="showStakeholderCard"
    :color="'white'"
    :bottom="true"
    :multi-line="true"
    :vertical="true"
    class="snackbar"
    :timeout="0"
  >
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-capitalize">
            {{ currentStakeholder.first_name }}
            {{ currentStakeholder.last_name }}
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-action />
      </v-list-item>
    </v-list>

    <v-divider />

    <v-list>
      <v-list-item
        v-if="!!currentStakeholder.email
        "
      >
        <v-icon>
          email
        </v-icon>
        <v-list-item-title>
          <a href="mailto:${currentStakeholder.email}">
            {{ currentStakeholder.email }}
          </a>
        </v-list-item-title>
      </v-list-item>
      <v-list-item>
        <v-icon>person_pin</v-icon>
        <v-list-item-title>
          <a
            :href="`//maps.google.com/maps?q=${formatAddress()}`"
            target="_blank"
          >{{
            formatAddress()
          }}</a>
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="!!currentStakeholder.phone">
        <v-icon>phone</v-icon>
        <v-list-item-title>
          {{ formatPhone() }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
    <v-btn
      color="grey"
      text
      @click="toggleStakeholderCard(false)"
    >
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: { currentStakeholder: { type: Object, default: () => {
    return {first_name: "", last_name: ""}
  } }},
  computed: {
    ...mapState("surveyResponseFiltering", ["showStakeholderCard"])
  },
  methods: {
    ...mapActions("surveyResponseFiltering", ["toggleStakeholderCard"]),
    formatPhone() {
      // Filter only numbers from the input
      let cleaned = ("" + this.currentStakeholder.phone).replace(/\D/g, "");
      // Check if the input is of correct length
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return "(" + match[1] + ") " + match[2] + "-" + match[3];
      }
      return null;
    },
    formatAddress() {
      const stakeholder = this.currentStakeholder;
      return [
        stakeholder.address,
        stakeholder.city,
        stakeholder.state,
        stakeholder.postal_code
      ]
        .filter(Boolean)
        .join(", ");
    }
  }
};
</script>

<style scoped>
.snackbar {
  padding: 1%;
}
</style>
